import React from 'react';

const Impressum: React.FC = () => (
  <section>
    <h2>Impressum</h2>

        <p>Gesellschaft f&uuml;r Energie- und Versorgungstechnik mbH<br />
        Andreas-Hofer-Stra&szlig;e 6<br />
        87452 Altusried</p>

        <p>Handelsregister: HRB 16600<br />
        Registergericht: Amtsgericht Kempten</p>

        <p><strong>Vertreten durch:</strong><br />
        Kurt Z&uuml;gner</p>

        <h2>Kontakt</h2>
        <p>Telefon: +49 8373 / 59449-0<br />
        E-Mail: info@w&auml;rmeplanung-bayern.de</p>

        <h2>Umsatzsteuer-ID</h2>
        <p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
        DE354816853</p>

        <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
        <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

        <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>  
</section>
);

export default Impressum;
